import { Card } from '@mui/material';

// import { StickyNoteToolbar } from './Toolbar/Toolbar';

import { GroupNodeToolbar } from './Toolbar';
import { useReactFlowViewContext } from '../../../../context/context';
import { type ReactFlowGroupNodeProps } from '../../BlockType/types';
import {
  REACT_FLOW_CARD_DEFAULT_BOX_SHADOW,
  REACT_FLOW_CARD_HIGHLIGHTED_BOX_SHADOW,
} from '../../constants';
import { ReactFlowDecoratorNodeResizer } from '../NodeResizer';
import { FLOW_DECORATION_SEMI_TRANSPARENT_COLORS } from '../constants';

const MIN_WIDTH = 100;
const MIN_HEIGHT = 100;

export function GroupNodeCard(props: ReactFlowGroupNodeProps) {
  const {
    width = MIN_WIDTH,
    height = MIN_HEIGHT,
    selected,
    data: { label, color },
  } = props;
  const { isEditable } = useReactFlowViewContext();

  return (
    <>
      <Card
        variant="outlined"
        role="group"
        aria-label={label}
        sx={{
          position: 'relative',
          ...FLOW_DECORATION_SEMI_TRANSPARENT_COLORS[color],
          color: '#00031a',
          boxShadow: REACT_FLOW_CARD_DEFAULT_BOX_SHADOW,
          '&:hover': {
            boxShadow: REACT_FLOW_CARD_HIGHLIGHTED_BOX_SHADOW,
          },
          width: Math.max(width, MIN_WIDTH),
          height: Math.max(height, MIN_HEIGHT),
          paddingX: 1,
          paddingY: 0.25,
        }}
      >
        {label}
      </Card>
      {isEditable && <GroupNodeToolbar {...props} />}
      {isEditable && (
        <ReactFlowDecoratorNodeResizer
          selected={selected}
          decorationColor={color}
          minWidth={MIN_WIDTH}
          minHeight={MIN_HEIGHT}
        />
      )}
    </>
  );
}
